import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ContentLoader from 'react-content-loader'
import clsx from 'clsx'
import { hasLocizeTranslation } from 'lib/utils/locize'
import { withI18next } from 'lib/i18n/withI18next'
import { getDeeplink } from 'components/custom-head/utils'
import QrCode from 'components/qr-code'
import Typo from 'constants/typography'
import Icon from 'components/common/icon'
import ICON, { ICON_SIZE } from 'components/common/icon/const'
import env from 'config/env'
import styles from './styles.scss'

function renderQRCodeSkeleton() {
  return (
    <React.Fragment>
      <style jsx>{styles}</style>
      <div className="product-qr-code-sections">
        <ContentLoader
          uniquekey="product-qr-code-section__content-loader"
          speed={2}
          width={200}
          height={80}
          primaryColor="#cfcece"
          secondaryColor="#ecebeb"
        >
          <rect x="0" y="0" rx="2" ry="2" width="60" height="72" />
          <rect x="70" y="36" rx="2" ry="2" width="100" height="5" />
          <rect x="70" y="50" rx="2" ry="2" width="200" height="5" />
        </ContentLoader>
      </div>
    </React.Fragment>
  )
}

const ProductQRCode = ({ product, t }) => {
  const [qrCodeLink, setqrCodeLink] = useState(null)
  const [isQRLoading, setIsQRLoading] = useState(true)

  useEffect(() => {
    if (!product || typeof window === 'undefined') {
      setIsQRLoading(false)
      return
    }

    const currentUrl = encodeURIComponent(window.location.href)
    const deeplink = getDeeplink('product', product?.id_product)
    const link = `${
      env.ROWT_HOST
    }3p?$3p=none&$fallback_url=${currentUrl}&$canonical_url=${currentUrl}&$ios_deeplink_path=${deeplink}&$android_deeplink_path=${deeplink}&$deeplink_path=${deeplink}&id=${
      product?.id_product || 0
    }`

    setqrCodeLink(link)
    setIsQRLoading(false)
  }, [product])

  if (isQRLoading) {
    return renderQRCodeSkeleton()
  }

  if (!qrCodeLink) {
    return null
  }

  return (
    <React.Fragment>
      <style jsx>{styles}</style>
      <div className="product-qr-code-sections">
        <div className="product-qr-code-wrapper">
          <div className="product-qr-code" alt="product qr code">
            <QrCode text={qrCodeLink} width={200} margin={2} hasLogo />
          </div>
          <div className={clsx('product-scan-text', Typo.price1)}>
            <Icon
              size={ICON_SIZE.smallMedium}
              alt="pdp wishlist icon"
              src={ICON.phoneScanQRCode}
            />
            <span>
              {hasLocizeTranslation(t, 'PDP_SCAN_ME_QR_CODE', 'Scan Me')}
            </span>
          </div>
        </div>
        <div className="product-qr-code-descriptions">
          <span className={Typo.subtitle2}>
            {hasLocizeTranslation(t, 'PDP_OPEN_IN_APP', 'Open in App')}
          </span>
          <span className={Typo.body2}>
            {hasLocizeTranslation(
              t,
              'PDP_DISCOUNT_DETAILS',
              'Get 15% off! on your first app order',
            )}
          </span>
        </div>
      </div>
    </React.Fragment>
  )
}

ProductQRCode.propTypes = {
  product: PropTypes.shape({
    id_product: PropTypes.number,
  }).isRequired,
  t: PropTypes.func.isRequired,
}

const Extended = withI18next()(ProductQRCode)

export default connect((state) => ({
  product: state.product.payload,
}))(Extended)
